/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { FormFieldComponentDelegate } from '../core/delegates/form-field-component-delegate';
import { CHIP_FIELD_CONSTANTS } from './chip-field-constants';
export class ChipFieldComponentDelegate extends FormFieldComponentDelegate {
    constructor(config) {
        super(config);
    }
    _build() {
        const chipField = document.createElement(CHIP_FIELD_CONSTANTS.elementName);
        this._inputElement = this._buildInputElement(chipField);
        if (this._config.options?.leadingElement) {
            this._config.options.leadingElement.slot = 'leading';
            chipField.appendChild(this._config.options.leadingElement);
        }
        if (this._config.options?.trailingElement) {
            this._config.options.trailingElement.slot = 'trailing';
            chipField.appendChild(this._config.options.trailingElement);
        }
        chipField.appendChild(this._inputElement);
        return chipField;
    }
    _configure() {
        if (this._config.options?.helperText) {
            this.setHelperText(this._config.options.helperText);
        }
        if (typeof this._config.options?.label === 'string') {
            this._createLabel(this._config.options.label);
        }
    }
    get value() {
        return this._inputElement.value;
    }
    set value(value) {
        this._inputElement.value = value;
    }
    get disabled() {
        return this._inputElement.disabled;
    }
    set disabled(value) {
        this._inputElement.disabled = value;
    }
    get invalid() {
        return this._element.invalid || false;
    }
    set invalid(value) {
        this._element.invalid = value;
    }
    get inputElement() {
        return this._inputElement;
    }
    get labelElement() {
        return this._labelElement;
    }
    onChange(listener) {
        this._inputElement.addEventListener('input', evt => listener(evt.target.value));
    }
    onFocus(listener) {
        this._inputElement.addEventListener('focus', evt => listener(evt));
    }
    onBlur(listener) {
        this._inputElement.addEventListener('blur', evt => listener(evt));
    }
    setLabel(text) {
        if (text) {
            if (this._labelElement) {
                this._labelElement.textContent = text;
            }
            else {
                this._createLabel(text);
            }
        }
        else if (this._labelElement) {
            this._element.removeChild(this._labelElement);
            this._labelElement = undefined;
        }
    }
    setHelperText(text) {
        if (text) {
            if (!this._helperTextElement) {
                this._helperTextElement = document.createElement('span');
                this._helperTextElement.slot = 'helper-text';
                this._element.appendChild(this._helperTextElement);
            }
            this._helperTextElement.textContent = text;
        }
        else if (this._helperTextElement) {
            this._element.removeChild(this._helperTextElement);
            this._helperTextElement = undefined;
        }
    }
    floatLabel(value) {
        this._element.floatLabel = value;
    }
    _createLabel(text) {
        this._labelElement = document.createElement('label');
        this._labelElement.textContent = text;
        if (this._config.options?.id) {
            this._labelElement.setAttribute('for', this._config.options.id);
        }
        this._element.appendChild(this._labelElement);
    }
    _buildInputElement(chipField) {
        const inputElement = document.createElement('input');
        inputElement.type = this._config.options?.type || 'text';
        if (this._config.options?.value !== undefined) {
            inputElement.value = this._config.options.value;
        }
        if (this._config.options?.id) {
            inputElement.id = this._config.options.id;
        }
        if (typeof this._config.options?.placeholder === 'string') {
            inputElement.placeholder = this._config.options?.placeholder;
        }
        chipField.appendChild(inputElement);
        return inputElement;
    }
}
